
import NotFound from '../containers/NotFound/NotFound';

const PageNotFound = () => <NotFound />;

export default PageNotFound;
